<template>
  <div class="autoCompleteContainer" @mouseleave="closeSuggestion" tabIndex="-1">
    <input
      :placeholder="placeholder"
      :style="{width: reactiveWidth}"
      type="text" ref="input"
      @input="updateValue($event.target.value)"
      :value="value"
      @focus="onFocus"
      @blur="lostFocus"
      @keydown.enter="enter"
      @keydown.down="down"
      @keydown.up="up"
    />
    <ul class="dropdown-menu" v-if="openSuggestion"         
        @mouseover="mouseover = true;" @mouseout="mouseover = false">
      <li
        v-for="(record, index) in matches"
        @mouseover="currentIndex = index"
        v-bind:class="{'active': isActive(index)}"

        @click="selectValue(index)"
        :key="index"
      >
        {{ record.displayValue }}
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: {
        passThruObject: { // The object the 'value' belongs to. Pass through to assign its value in the onValueChanged function you pass in
            type: Object
        },
        placeholder: {
            type: String,
            default: "Start Typing"
        },
        value: { // The string used to search the list for matches
            type: String
        },
        data: {   //formatted as displayValue, searchValue
            type: Array,
        },
        numRecordsToDisplay: {
            type: Number,
            default: 15,
        },
        searchField: { // The property of each data object to search
            type: String,
            required: true
        },
        displayField: { // The property of each data object that's displayed in the list
            type: String,
            required: true        
        },
        internalValueField: { 
            type: String,
            required: true
        },
        onValueChanged: { // You must manually assign the new value to the relevant property in this function
            type: Function
        },
        onBlur: {
            type: Function
        },
        allowCustomText: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            open: false,
            currentIndex: 0,
            internalValue: '',
            mouseover: false, 

        }
    },
    computed: {
        // Filtering the suggestion based on the input
        matches () {    
            var matchList = this.data;
            if(Array.isArray(this.value))
                return false;
            else if(this.value && this.value != '') {
                var searchValue = this.value.searchValue ? this.value.searchValue.toLowerCase() : this.value.toLowerCase();
                matchList = this.data.filter((obj) => {
                    if(!this.searchField) return false;
                    if(obj[this.searchField].toLowerCase().indexOf(searchValue) >= 0)
                            return true;

                    return false;
                });
            }

            if(matchList.length > this.numRecordsToDisplay) {
                matchList = matchList.slice(0, this.numRecordsToDisplay);
            }
            matchList.forEach(obj => {
                obj.displayValue = this.getDisplayValue(obj);
            });

            return matchList;
        },
        openSuggestion () {
         return  this.matches.length !== 0 &&
                    this.open === true 
        },
        reactiveWidth() {
         if(this.value == undefined || this.value === '' || this.value.length < 30)
                return "30ch";
            else if(this.value.length > 60)
                return "60ch";
            else 
                return this.value.length + 'ch';
        }
    },
    methods: {
        // Triggered the input event to cascade the updates to
        // parent component
        updateValue (value) {
            this.showSuggestion();
            this.valueChanged(value);
        },
        valueChanged(newValue) {
            if(this.onValueChanged)
                this.onValueChanged(this.passThruObject, (newValue?.trim() ?? ''));
        },
        onFocus() {
         this.$refs.input.select();
            if((this.value ?? '') === '')
                this.showSuggestion();
        },
        showSuggestion() {
        if (this.open === false) {
                this.open = true;
                this.currentIndex = 0;
            }
        },
        hideSuggestion() {
            this.open = false;
        },
        // When enter key pressed on the input
        enter () {
            if(!this.open || this.matches.length == 0) 
                return;
            
            this.selectValue(this.currentIndex);
        },
        // When up arrow pressed while suggestions are open
        up () {
        if(!this.open || this.matches.length == 0) return;
            if (this.currentIndex > 0) {
                this.currentIndex--
            }
        },
        // When down arrow pressed while suggestions are open
        down () {
             if(!this.open || this.matches.length == 0) return;
            if (this.currentIndex < this.matches.length - 1) {
                this.currentIndex++
            }
        },
        // For highlighting element
        isActive (index) {
            return index === this.currentIndex
        },
        // When one of the suggestion is clicked
        selectValue (index) {
            this.setDisplayValue(this.matches[index]);
            this.hideSuggestion();
            if(this.onBlur)
                this.onBlur(this.passThruObject, this.getDisplayValue(this.matches[index])?.trim() ?? ''); 
        },
        setDisplayValue(record) {
           this.valueChanged(this.getDisplayValue(record));
           this.mouseover = false;
        },
        getDisplayValue(record) {
            if(!this.displayField) {
                this.internalValue = '';
                return '';
            }
            else {
                this.internalValue = record[this.internalValueField];
                return record[this.displayField];
            }
        },
        lostFocus() {
            if(!this.allowCustomText) {
                if(this.mouseover === false)
                {
                    if((this.value ?? '').trim() === '' ) {
                        this.valueChanged(this.getDisplayValue(''));
                        //this.$emit('update:value',  '');
                        return;
                    }

                    var checkValue = this.value.toLowerCase();
                    var valid = true;
                    if(this.searchField === '') 
                        valid = false;
                    else { 
                        var search = this.data.find((obj) => obj[this.searchField].toLowerCase() === checkValue);
                        
                        if(search == undefined) valid = false;
                        else if(search[this.searchField] != this.value)
                        this.valueChanged(this.getDisplayValue(search));
                    }


                    if(valid == false)
                        this.valueChanged('');                    
                }
            }
            if(this.onBlur) {
                let newValue;
                if(this.mouseover && this.matches.length > 0)
                    newValue = this.matches[this.currentIndex].displayValue;
                else if(this.$refs.input.value && this.$refs.input.value !== '')
                    newValue = this.$refs.input.value 
                else
                    newValue = '';
                this.onBlur(this.passThruObject, newValue);
            }
            this.hideSuggestion();
        }
    }    
  };
</script>
<style scoped>
    .autoCompleteContainer {
        position: relative;
    }

    .autoCompleteContainer .dropdown-menu {
        list-style-type: none;
        font-weight: normal;
        font-size: smaller;
        line-height: 30px;
        max-width: fit-content;
        border: solid 2px #2c3e50;
        padding: 0px;
        margin-top:22px;
        border-radius: 5px;
        background-color: white;
        position: absolute;
        z-index: 100;
        cursor: pointer;
    }

    .autoCompleteContainer .dropdown-menu li {
        text-decoration: none;
        color: #2c3e50;
        padding: 0px 10px;
    }

    .autoCompleteContainer .dropdown-menu li.active {
        background-color: #2c3e50;
        color: white;
    }
</style>
